import React, { useEffect } from 'react';
import { useClickOutside } from '../../../../../../hooks';
import { autoBetCountList, autoBetDataKeys, globalTranslationKeys } from '../../../../../../enums';

const AutoBet = ({
  t,
  isStart,
  doBetSender,
  autoBetData,
  currentWinOdd,
  activeFreeBetMinOdd,
  handleChangeAutoBet,
  updateIsDisabledBetSection,
}) => {
  const [ref, hasOutsideClick] = useClickOutside();
  const { isAutoBet, isOpened, autoBetCount } = autoBetData;

  const handleOpenAutoBetCountList = () => {
    if (isAutoBet) {
      handleChangeAutoBet(autoBetDataKeys.isAutoBet, false);
      handleChangeAutoBet(autoBetDataKeys.autoBetCount, 0);
      updateIsDisabledBetSection(false);
    } else {
      handleChangeAutoBet(autoBetDataKeys.isOpened, true);
    }
  };

  const handleClickAutoBetCount = (item) => {
    handleChangeAutoBet(autoBetDataKeys.autoBetCount, Number(item));
    handleChangeAutoBet(autoBetDataKeys.isAutoBet, true);
    handleChangeAutoBet(autoBetDataKeys.isOpened, false);
    if (isStart) {
      doBetSender();
    } else {
      updateIsDisabledBetSection(true);
    }
  };

  useEffect(() => {
    if (hasOutsideClick) {
      handleChangeAutoBet(autoBetDataKeys.isOpened, false);
      handleChangeAutoBet(autoBetDataKeys.isAutoBet, false);
      handleChangeAutoBet(autoBetDataKeys.autoBetCount, 0);
    }
  }, [hasOutsideClick]);
  return (
    <div
      className={`striker-btn-count-wrp ${
        activeFreeBetMinOdd && currentWinOdd < activeFreeBetMinOdd ? 'passive' : ''
      }`}
      {...(isOpened ? { ref: ref } : {})}
    >
      {' '}
      <div className='striker-btn-count-holder'>
        {isOpened ? (
          <div className='striker-btn-count-inner'>
            {autoBetCountList.map((item) => {
              return (
                <span onClick={() => handleClickAutoBetCount(item)} key={item} title={item || ''}>
                  {item}
                </span>
              );
            })}
          </div>
        ) : (
          <div className='striker-autobet-wrp'>
            <p className='striker-autobet-txt' title={t(globalTranslationKeys.AutoBet)}>
              {t(globalTranslationKeys.AutoBet)}
            </p>

            {!isAutoBet || (isAutoBet && !autoBetCount) ? (
              <div
                className='striker-autobet-switch'
                onClick={handleOpenAutoBetCountList}
                title={t(globalTranslationKeys.AutoBet)}
              >
                {' '}
                {/* add/remove active */}
                <span className='striker-switcher-thumb' />
              </div>
            ) : (
              <></>
            )}

            {isAutoBet && autoBetCount ? (
              <div className='striker-autobet-only-count'>{autoBetCount}</div>
            ) : (
              <></>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default AutoBet;
